export type HasId = {
  id: string;
};

export const IdComparator = <T extends HasId>(l: T, r: T): boolean => l.id === r.id;

export const updateInList = <T>({
  addToList = false,
  list,
  updatedItem,
  comparator,
}: {
  addToList?: boolean;
  list: Array<T>;
  updatedItem: T;
  comparator: (first: T, second: T) => boolean;
}): void => {
  const index = list.findIndex((item) => comparator(item, updatedItem));
  if (index !== -1) {
    list[index] = updatedItem;
  } else if (addToList) {
    list.unshift(updatedItem);
  }
};
